module.exports = __webpack_public_path__ + "SS.png?ba2b908451fff599f6504caa62d3f67f";